module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fin-deci-text",
    style: (_vm.estilos),
    attrs: {
      "id": "texto-final",
      "tabindex": "1"
    }
  }, [_c('v-flex', {
    attrs: {
      "text-xs-right": ""
    }
  }, [_c('ui-lsc-dialog', {
    attrs: {
      "vidTittle": 'Conclusión',
      "videoEmbed": _vm.video
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-ocul"
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.finTitulos) ? _c('div', {
    attrs: {
      "aria-label": _vm.finTitulos[0] + _vm.finTitulos[1] + _vm.finTitulos[2]
    }
  }, [_c('div', {
    staticClass: "text-ocul"
  }, [_c('p', [_vm._v(_vm._s(_vm.finTitulos[0] + _vm.finTitulos[1] + _vm.finTitulos[2]))])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('p', {
    staticClass: "font-red davi-curs fint-titu-1"
  }, [_vm._v(_vm._s(_vm.finTitulos[0]))])]), _vm._v(" "), _c('div', {
    staticClass: "fint-titu-2",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.finTitulos[1]))])]), _vm._v(" "), _c('div', {
    staticClass: "fint-titu-3",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('p', [_c('image-app', {
    attrs: {
      "imaSize": 30,
      "imaSrc": "design/red-arrow",
      "imaAlt": ""
    }
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.finTitulos[2]))])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.finTitulosDos) ? _c('div', [_c('p', {
    staticClass: "font-red davi-curs fint-titu-1"
  }, [_c('image-app', {
    attrs: {
      "imaSize": 30,
      "imaSrc": "design/red-arrow",
      "imaAlt": ""
    }
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.finTitulosDos))])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fin-titu-cont"
  }, [_vm._t("default"), _vm._v(" "), _c('button', {
    attrs: {
      "tabindex": "1",
      "aria-label": "Volver al inicio"
    },
    on: {
      "click": function($event) {
        _vm.backIni()
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "tabindex": "1",
      "aria-label": "Continuar curso"
    },
    on: {
      "click": function($event) {
        _vm.finDeci()
      }
    }
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21fd6cb8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actividades/ActividadDeciTituUno.vue
// module id = 953
// module chunks = 1